import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_FRONT_CART_CHOICE_BANNER}`;

export const getFinishedAd = (param = {}) => axios.get(API_PATH, { params: param });
